import template from "./phone-msg.html";
import {phoneMsgController} from "./phone-msg.controller";
import "./phone-msg.scss";

export const phoneMsgComponent = {
    template,
    controller: phoneMsgController,
    controllerAs: "phoneMsg",
    bindings: {
        text: "<"
    }
};


// WEBPACK FOOTER //
// ./sources/components/common/phone-msg/phone-msg.component.js